import api from "./api";

/** Resposta bruta do Melhor Envio (`GET /api/v2/me/balance` via backend). */
export type MelhorEnvioSaldoApiPayload = unknown;

/**
 * Saldo na carteira Melhor Envio (proxy: `GET /loja/frete/saldo`).
 * O corpo segue o JSON retornado pela API do ME (ex.: campo `balance`).
 */
export async function getMelhorEnvioSaldo() {
  return api.get<MelhorEnvioSaldoApiPayload>("/loja/frete/saldo");
}

/**
 * Insere frete no carrinho do Melhor Envio (antes do checkout).
 * Corpo conforme doc ME: `service`, `from`, `to`, `products`, `volumes`, `options`, etc.
 * @see https://docs.melhorenvio.com.br/reference/inserir-fretes-no-carrinho
 */
export async function inserirCarrinhoMelhorEnvio(
  body: Record<string, unknown>
) {
  return api.post("/loja/frete/melhor-envio/cart", body);
}

/**
 * Pagamento dos envios no carrinho do Melhor Envio (usa saldo da carteira ME).
 * `orders`: ids retornados ao inserir fretes no carrinho.
 * @see https://docs.melhorenvio.com.br/reference/compra-de-fretes-1
 */
export async function checkoutMelhorEnvio(orders: string[]) {
  return api.post("/loja/frete/melhor-envio/checkout", { orders });
}

/** IDs de envio (UUID) no Melhor Envio — após compra no carrinho ME. */
export async function gerarEtiquetasMelhorEnvio(orders: string[]) {
  return api.post("/loja/frete/melhor-envio/etiquetas/gerar", { orders });
}

/** Retorna `{ url }` para abrir a página de impressão no Melhor Envio. */
export async function imprimirEtiquetasMelhorEnvio(body: {
  orders: string[];
  mode?: "private" | "public";
}) {
  return api.post("/loja/frete/melhor-envio/etiquetas/imprimir", body);
}
